import { $api } from "../generated/client";

type UseGetReturnRequestParams = {
  shopId: string;
  returnRequestId: string;
};

export function useGetReturnRequestSuspense(params: UseGetReturnRequestParams) {
  return $api.useSuspenseQuery("get", "/shops/{shopId}/return-requests/{returnRequestId}", {
    params: { 
      path: { 
        shopId: params.shopId, 
        returnRequestId: params.returnRequestId 
      } 
    },
  });
}
